import React, { useEffect, useState } from "react";
import { getPolls, submitVote } from "../services/pollService";

const SideBarPolls = () => {
  const [polls, setPolls] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [votedPolls, setVotedPolls] = useState([]);

  useEffect(() => {
    fetchPolls();
    const storedVotedPolls = JSON.parse(localStorage.getItem("votedPolls")) || [];
    setVotedPolls(storedVotedPolls);
  }, []);

  const fetchPolls = async () => {
    try {
      const response = await getPolls({ pageNumber: 1, pageSize: 5, filterText: "" });
      if (response.data) {
        setPolls(response.data);
      }
    } catch (error) {
      console.error("Error fetching polls:", error);
    }
  };

  const handleOptionChange = (pollId, optionId) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [pollId]: optionId,
    }));
  };

  const handleVote = async (pollId) => {
    if (votedPolls.includes(pollId)) {
      alert("You have already voted in this poll.");
      return;
    }

    const selectedOptionId = selectedOptions[pollId];
    if (!selectedOptionId) {
      alert("Please select an option before voting!");
      return;
    }

    try {
      const response = await submitVote(pollId, selectedOptionId);

      if (response.message === "User has already voted.") {
        alert("You have already voted in this poll.");
        return;
      }

      if (response.success) {
        alert("Vote submitted successfully!");
        await fetchPolls(); // Refresh the poll list

        const updatedVotedPolls = [...votedPolls, pollId];
        localStorage.setItem("votedPolls", JSON.stringify(updatedVotedPolls));
        setVotedPolls(updatedVotedPolls);
      } else {
        alert(response.message || "Failed to submit vote. Try again!");
      }
    } catch (error) {
      console.error("Error submitting vote:", error);
      alert("An error occurred while submitting your vote. Please try again.");
    }
  };

  return (
    <div className="poll-container">
      <h2 className="sidebar-title">📌 Trending Polls</h2>
      {polls.length === 0 ? (
        <p className="no-polls">No active polls available.</p>
      ) : (
        polls.map((poll) => {
          const totalVotes = poll.options.reduce((sum, option) => sum + option.totalResponses, 0);

          return (
            <div key={poll.id} className="poll-card">
              <h3 className="poll-question">{poll.question}</h3>
              <div className="poll-options">
                {poll.options.map((option) => {
                  const percentage = totalVotes ? ((option.totalResponses / totalVotes) * 100).toFixed(1) : 0;

                  return (
                    <label key={option.optionId} className="poll-option">
                      <input
                        type="radio"
                        name={`poll-${poll.id}`}
                        value={option.optionId}
                        checked={selectedOptions[poll.id] === option.optionId}
                        onChange={() => handleOptionChange(poll.id, option.optionId)}
                        disabled={votedPolls.includes(poll.id)}
                      />
                      <span className="option-text">{option.optionText}</span>
                      <span className="vote-percent">({percentage}%)</span>
                    </label>
                  );
                })}
              </div>
              <button
                className="vote-button"
                onClick={() => handleVote(poll.id)}
                disabled={votedPolls.includes(poll.id)}
              >
                {votedPolls.includes(poll.id) ? "Already Voted" : "Vote"}
              </button>
            </div>
          );
        })
      )}
    </div>
  );
};

export default SideBarPolls;
